import { Spacer, Text, TextBold } from "@views/common/ProductDetails/common"
import React from "react"

interface DeliveryTextProps {
  deliveryDate: string
  orderWithin: string
}

const DeliveryText: React.FC<DeliveryTextProps> = ({
  deliveryDate,
  orderWithin,
}) => (
  <>
    <Text>Get it by</Text>
    <Spacer />
    <TextBold>{deliveryDate}</TextBold>
    <Spacer />
    <Text>order within</Text>
    <Spacer />
    <TextBold>{orderWithin}</TextBold>
  </>
)

export default DeliveryText
